import {
  DashboardTipsAdminGrid,
  publicDashboardTipAssetUrl,
  type DashboardTipsAdminApi
} from '@jarvis/platform-ui';
import { useMemo } from 'react';
import {
  createDashboardTipsAdminApi,
  HUB_DASHBOARD_TIPS_API_BASE,
  WEBOPS_TIP_DEFAULT_MIN_ROLE,
  WEBOPS_TIP_MIN_ROLE_OPTIONS
} from '../../../api/dashboardTips';

export function DashboardTipsAdminPage() {
  const api = useMemo<DashboardTipsAdminApi>(
    () => createDashboardTipsAdminApi(HUB_DASHBOARD_TIPS_API_BASE),
    []
  );

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <DashboardTipsAdminGrid
          api={api}
          stateStorageKey="webopsui:dashboard-tips-grid"
          minRoleOptions={WEBOPS_TIP_MIN_ROLE_OPTIONS}
          defaultMinRole={WEBOPS_TIP_DEFAULT_MIN_ROLE}
          assetUrl={publicDashboardTipAssetUrl}
        />
      </div>
    </div>
  );
}
